import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { checkIfOnlySelect, flattedArrayByKey, injectVariablesToQuery, parseRangeQuery } from '../../utils/helpers';
import SelectBuilder, { SelectTable } from '../SelectBuilder/SelectBuilder';
import SimpleCodeEditor from '../SimpleCodeEditor/SimpleCodeEditor';

const EditRangeQuery = () => {
  const dispatch = useDispatch();
  const { condition_id } = useParams();
  const [changeTableClicked, setChangeTableClicked] = useState(false);

  const { condition, testRangeQuery, sqlValues, pgDbs } = useSelector((state) => state.general);
  const [query, setQuery] = useState(undefined);
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      }),
    );
    dispatch(apiAction({ reduxField: 'sqlValues', route: 'sqlValues/getSqlValues' }));
    dispatch(apiAction({ reduxField: 'pgDbs', route: 'conditions/getDbIds' }));
  }, []);

  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      }),
    );
  }
  const columns = flattedArrayByKey(condition?.columns, 'table_name');

  console.log({ query, testRangeQuery, sqlValues, pgDbs, condition });
  const isManualQuery = condition?.rangeQuery?.isManualQuery;
  const highlightedRangeQuery = isManualQuery
    ? injectVariablesToQuery(condition?.rangeQuery?.manualQuery || '', sqlValues?.data)
    : parseRangeQuery(condition);
  const syntaxHighlighterValue =
    typeof highlightedRangeQuery === 'string'
      ? highlightedRangeQuery
      : JSON.stringify(highlightedRangeQuery ?? '', null, 2);
  return condition?._id && Array.isArray(sqlValues?.data) ? (
    <div>
      <div className='row justify-content-left align-items-center mt-2'>
        <div className='col-md-12'>
          <Link className='btn btn-sm btn-outline-dark border-0' to={`/condition/${condition._id}`}>
            Back to Condition Details
          </Link>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Edit Range Query</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h3>
          <Link className='text-primary' to={`/condition/${condition._id}`}>
            {condition.name}
          </Link>
        </h3>
      </div>{' '}
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <button
          className={`btn btn${isManualQuery ? '' : '-outline'}-primary`}
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'condition',
                route: 'conditions/updateRangeQuery',
                conditionId: condition._id,
                rangeQuery: { ...condition.rangeQuery, isManualQuery: !isManualQuery },
              }),
            );
          }}
        >
          Use Manual Query
        </button>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div>
          <label>Select Database</label>
          <select
            className='form-control'
            value={condition.rangeQuery?.db_id || ''}
            onChange={(e) => {
              dispatch(
                apiAction({
                  reduxField: 'condition',
                  route: 'conditions/updateRangeQuery',
                  conditionId: condition._id,
                  rangeQuery: { ...condition.rangeQuery, db_id: e.target.value },
                }),
              );
            }}
          >
            {pgDbs?.map((db) => (
              <option key={db.id} value={db.id}>
                {db.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {isManualQuery ? (
        <>
          <>
            <div className='row justify-content-center align-items-center mt-4'>
              <h4>Selected Table </h4>
            </div>

            {changeTableClicked ? (
              <SelectTable
                dispatch={dispatch}
                condition={condition}
                columns={columns}
                setChangeTableClicked={setChangeTableClicked}
              />
            ) : (
              <div className='row justify-content-center align-items-center border-bottom mt-2'>
                <h6>
                  <button
                    className='btn btn-outline-dark'
                    title='Click to Change Table'
                    onClick={() => setChangeTableClicked(true)}
                  >
                    <i className='fa-solid fa-table'></i> {condition.rangeQuery.table_name}
                  </button>
                </h6>
              </div>
            )}
            <div className='row justify-content-center align-items-center mt-4'>
              <h4>Columns to use as Variables</h4>
            </div>
            <div className='row justify-content-center align-items-center '>
              {!condition.rangeQuery.columnsIds || condition.rangeQuery.columnsIds.length < 1 ? (
                <small className='text-danger'>Please add at least one column</small>
              ) : null}
            </div>
            <>
              <div className='row justify-content-center align-items-center border-bottom mt-2 p-3'>
                {condition.columns
                  ?.filter((col) => col.table_name === condition.rangeQuery?.table_name)
                  .map((col) => {
                    return (
                      <button
                        key={col.column_name}
                        className={`btn btn-sm btn${
                          condition.rangeQuery?.columnsIds?.includes(col._id) ? '' : '-outline'
                        }-primary m-1`}
                        onClick={() =>
                          condition.rangeQuery?.columnsIds?.includes(col._id)
                            ? dispatch(
                                apiAction({
                                  reduxField: 'condition',
                                  route: 'conditions/updateRangeQuery',
                                  conditionId: condition._id,
                                  rangeQuery: {
                                    ...condition.rangeQuery,
                                    columnsIds: condition.rangeQuery?.columnsIds?.filter((flt) => flt !== col._id),
                                  },
                                }),
                              )
                            : dispatch(
                                apiAction({
                                  reduxField: 'condition',
                                  route: 'conditions/updateRangeQuery',
                                  conditionId: condition._id,
                                  rangeQuery: {
                                    ...condition.rangeQuery,
                                    columnsIds: Array.isArray(condition.rangeQuery?.columnsIds)
                                      ? [...condition.rangeQuery.columnsIds, col._id]
                                      : [col._id],
                                  },
                                }),
                              )
                        }
                      >
                        {col.column_name}
                      </button>
                    );
                  })}
              </div>
            </>
          </>
          <div
            className='row d-flex justify-content-center border p-3 mt-2 mb-2'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <div className='col-md-8'>
              <SimpleCodeEditor text={query || condition.rangeQuery?.manualQuery} setText={setQuery} />
            </div>
          </div>
          {query && query !== condition.rangeQuery?.manualQuery ? (
            <div className='row d-flex justify-content-center mt-2 mb-2' data-aos='fade-up' data-aos-delay='200'>
              <button
                className='btn btn-outline-primary'
                onClick={() => {
                  const check = checkIfOnlySelect(query);
                  if (!check) {
                    return alert('Please provide a valid SELECT query');
                  }
                  dispatch(
                    apiAction({
                      reduxField: 'condition',
                      route: 'conditions/updateRangeQuery',
                      conditionId: condition._id,
                      rangeQuery: { ...condition.rangeQuery, manualQuery: query },
                    }),
                  );
                }}
              >
                Save Query
              </button>
            </div>
          ) : null}
        </>
      ) : (
        <SelectBuilder condition={condition} />
      )}
      <div className='row d-flex justify-content-center border p-3 mt-2 mb-2' data-aos='fade-up' data-aos-delay='200'>
        <h4>Range Query</h4>
        <div
          className='col-md-12 d-flex justify-content-center flex-wrap'
          onClick={() => {
            if (typeof query !== 'string') {
              setQuery(condition.rangeQuery.manualQuery);
            }
          }}
        >
          <SyntaxHighlighter language='sql' wrapLines={true}>
            {syntaxHighlighterValue}
          </SyntaxHighlighter>
        </div>
      </div>
      <div className='row d-flex justify-content-center border p-3 mt-2 mb-2' data-aos='fade-up' data-aos-delay='200'>
        <a
          className='btn btn-outline-primary'
          href={`/testRangeQuery/${condition._id}`}
          target='_blank'
          rel='noreferrer'
        >
          Test Range Query
        </a>
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default EditRangeQuery;
